import { Link } from "@tanstack/react-router";
import { Phone, MessageSquare, MapPin, Mail } from "lucide-react";
import { BUSINESS } from "@/lib/contact";
import logoImg from "@/assets/logo.webp";

const cities = [
  "Sacramento",
  "Roseville",
  "Rocklin",
  "Folsom",
  "Elk Grove",
  "Antelope",
  "Citrus Heights",
  "Carmichael",
];

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-secondary/40 pb-28 sm:pb-12">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <Link to="/" className="flex items-center gap-2.5">
            <img
              src={logoImg}
              alt="StillFusion Appliance Repair logo"
              width={44}
              height={44}
              className="h-11 w-11 rounded-lg object-cover"
            />
            <span className="leading-tight">
              <span className="block text-base font-semibold tracking-tight">
                {BUSINESS.name}
              </span>
              <span className="block text-xs text-muted-foreground">
                Appliance Repair · {BUSINESS.city}
              </span>
            </span>
          </Link>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-muted-foreground">
            Fast, reliable, same-day appliance repair across the Sacramento
            area. Licensed, insured, and trusted by homeowners.
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wider text-foreground">
            Contact
          </h3>
          <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
            <li>
              <a
                href={`tel:${BUSINESS.phone}`}
                className="inline-flex items-center gap-2 hover:text-primary"
              >
                <Phone className="h-4 w-4 text-primary" />
                Call Now
              </a>
            </li>
            <li>
              <a
                href={`sms:${BUSINESS.sms}`}
                className="inline-flex items-center gap-2 hover:text-primary"
              >
                <MessageSquare className="h-4 w-4 text-primary" />
                Text us
              </a>
            </li>
            <li>
              <a
                href={`mailto:${BUSINESS.email}`}
                className="inline-flex items-center gap-2 hover:text-primary"
              >
                <Mail className="h-4 w-4 text-primary" />
                {BUSINESS.email}
              </a>
            </li>
            <li className="inline-flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 text-primary" />
              <span>{BUSINESS.city}</span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wider text-foreground">
            Service Area
          </h3>
          <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-2 text-sm text-muted-foreground">
            {cities.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-5 py-5 text-xs text-muted-foreground sm:flex-row">
          <span>
            © {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.
          </span>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
            <Link to="/services" className="hover:text-primary">Services</Link>
            <Link to="/about" className="hover:text-primary">About</Link>
            <Link to="/reviews" className="hover:text-primary">Reviews</Link>
            <Link to="/contact" className="hover:text-primary">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
